import { gql } from '@apollo/client';

export const GET_ALL_GENRES = gql`
  query GET_ALL_GENRES {
    getAllGenres {
      id
      name
    }
  }
`;